var _defs, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1_Caf\\xE9",
    "data-name": "1 Caf\\xE9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.82 118.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;stroke:#343233;stroke-width:3.31px;}.cls-1{stroke-miterlimit:10;}.cls-2{isolation:isolate;}.cls-3{stroke-linecap:round;stroke-linejoin:round;}.cls-4{fill:#d83f28;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.18,91.75l-.26,10.09a10.92,10.92,0,0,1-5.59,9.32c-.86.48-1.71.89-2.44,1.3-11,4.87-24.18,8.62-44.13,8.72a32.67,32.67,0,0,1-6.84-.62c-3.35-.7-5.42-1.73-6.77-3.3l0,0c-2.61-3-2.57-8.12-3.94-16.77L26.36,29.7a.19.19,0,0,0,0-.08v-.26a1.19,1.19,0,0,1,1-.92l70.36-9.89,5.9,58.36A114.87,114.87,0,0,1,104.18,91.75Z",
    transform: "translate(-23.05 -4.78)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.12,117.23,28.29,109c-3.56-3.82-3.69-7.58-3.55-10.74l1.61-68.6a.19.19,0,0,1,0,.08l7.82,70.76C35.55,109.11,35.51,114.2,38.12,117.23Z",
    transform: "translate(-23.05 -4.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.84,18.58V14.07L97.54,14a1,1,0,0,1-.64-1,1.35,1.35,0,0,1,.67-1.13l.28-.19v-2a3,3,0,0,0-3.43-3.22l-64.6,9.07a4.32,4.32,0,0,0-3.47,4.2v2l.3.1a.93.93,0,0,1,.65.94,1.32,1.32,0,0,1-.62,1.15l-.33.21,0,4.51,0,.73v.26",
    transform: "translate(-23.05 -4.78)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-4",
    d: "M63.22,75.27a6.79,6.79,0,0,0-1.45,4.25,6.09,6.09,0,0,0,.65,2.81,6.38,6.38,0,0,0,1.77,2.16,8.36,8.36,0,0,0,2.61,1.39,9.7,9.7,0,0,0,3.19.51,11.34,11.34,0,0,0,4.29-.83A12.81,12.81,0,0,0,78,83.19l-11-11.53a17.39,17.39,0,0,0-3.87,3.61m2.57-20.62A4.45,4.45,0,0,0,64.31,58a3.8,3.8,0,0,0,.18,1.16,5.5,5.5,0,0,0,.62,1.24A17.42,17.42,0,0,0,66.35,62c.54.61,1.2,1.33,2,2.15a30.43,30.43,0,0,0,4.31-3.28,4.56,4.56,0,0,0,1.6-3.4,3.84,3.84,0,0,0-1.33-3.05,5.05,5.05,0,0,0-3.4-1.15,5.23,5.23,0,0,0-3.73,1.39",
    transform: "translate(-23.05 -4.78)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneBag);
export default __webpack_public_path__ + "static/media/one-bag.e69559d48dc6a262295c565061c580ee.svg";
export { ForwardRef as ReactComponent };